module.exports = __webpack_public_path__ + "static/media/piano-keyboard.8d3d8d44.svg";